import boxIcon from "../assets/icons/box.png";

const NotFound = ({ text1, text2 }) => {
  return (
    <div
      className="font-inter text-[15px] text-[rgb(112,112,112)] flex flex-col gap-[10px] items-center justify-center h-[188px] w-full bg-white rounded-[10px]"
      style={{ boxShadow: "0px 4px 4px 0px #0000000F" }}
    >
      <img src={boxIcon} className="w-[38px] h-[38px]" alt="" />
      <p>{text1 || "No support requests found"}</p>
      <p>
        {text2 || "No support requests match your current filter criteria."}
      </p>
    </div>
  );
};

export default NotFound;
